// extracted by mini-css-extract-plugin
export default {"accordian_heading":"auditFromStyles_accordian_heading__+-u-B","label_margin":"auditFromStyles_label_margin__63XMv","upload_div":"auditFromStyles_upload_div__1FBTZ"};